import { TagManagerScriptAdapter } from "./TagmanagerScriptAdapter";
import { AnalyticsScriptAdapter } from "../statistics/AnalyticsStatisticsAdapter";
import { FacebookScriptAdapter } from "./FacebookScriptAdapter";
export class ScriptManager {
    constructor(contextDocument, contextWindow) {
        this._adaptersList = {};
        this._lazyCalled = false;
        this._contextDocument = contextDocument;
        this._contextWindow = contextWindow;
    }
    activateScripts(scriptsData) {
        const adapters = [];
        if (scriptsData.adapters) {
            scriptsData.adapters.forEach((adapterName) => {
                const adapter = this.createAdapter(adapterName);
                if (adapter) {
                    adapters.push(adapter);
                }
            });
        }
        return adapters;
    }
    getScripts(adapter, optional = false) {
        if (this._adaptersList[adapter]) {
            return this._adaptersList[adapter];
        }
        else if (!optional) {
            logger.error(new Error(adapter + ' doesnt exists.'));
        }
        return [];
    }
    activateScriptOnce(scriptData) {
        if (!this._adaptersList[scriptData.adapter]) {
            return this.createAdapter(scriptData);
        }
        return null;
    }
    createAdapter(scriptData) {
        let adapter = null;
        if (scriptData && scriptData.adapter) {
            try {
                switch (scriptData.adapter) {
                    case 'google.tagmanager':
                        adapter = new TagManagerScriptAdapter(this._contextWindow, this._contextDocument);
                        break;
                    case 'google.analytics':
                        adapter = new AnalyticsScriptAdapter(this._contextWindow, this._contextDocument);
                        break;
                    case '__facebook':
                        adapter = new FacebookScriptAdapter(this._contextWindow, this._contextDocument);
                        break;
                }
                if (adapter) {
                    if (!this._adaptersList[scriptData.adapter]) {
                        this._adaptersList[scriptData.adapter] = [];
                    }
                    this._adaptersList[scriptData.adapter].push(adapter);
                    adapter.init(scriptData);
                    if (this._lazyCalled) {
                        adapter.initLazy();
                    }
                }
                logger.log(scriptData.adapter + ' created.');
            }
            catch (error) {
                logger.error(scriptData.adapter + ' not created.', error.stack);
            }
        }
        return adapter;
    }
    loadLazy() {
        this._lazyCalled = true;
        for (let adaperName in this._adaptersList) {
            this._adaptersList[adaperName].forEach((adapter) => {
                adapter.initLazy();
            });
        }
    }
    get contextWindow() {
        return this._contextWindow;
    }
    get contextDocument() {
        return this._contextDocument;
    }
}
